

export interface TimeExpenseEntry {
    readonly id?: string | null
    readonly description?: string | null
    readonly entryDate?: string
    readonly activityType?: ActivityTypeEnum
    readonly billingRate?: number
    readonly tHoursDurationQuantity?: number
    readonly billingCost?: number
    readonly matter?: Matter
    readonly user?: User
    readonly userName?: string
    readonly userId?: string
    readonly invoiceNumbers?: InvoiceNumber[]
    readonly invoiceId?: string
    readonly isNonBillable?: boolean
    readonly isVisibleToBill?: boolean
    readonly taxId?: string
    readonly utbmsExpenseCodeId?: string
    readonly utbmsTaskCodeId?: string
    readonly activityCategoryUtbmsCodeId?: string
    readonly utbmsType?: boolean
    readonly expenseCategoryId?: string
    readonly matterId?: null | string
    readonly durationInSeconds?: number | null
    readonly isTaxable?: boolean
    readonly appliedTaxOnInvoice?: null
    readonly privateNote?: null
    readonly tagResourceId?: null
    readonly isTimerRunning?: boolean | null
    readonly writtenOff?: null
    readonly resourceId?: string
    readonly resourcetype?: ResourceTypeEnum
    readonly parent?: string
    readonly isActive?: boolean
    readonly metadata?: any
    readonly isDeleted?: boolean
    readonly deletedBy?: string
    readonly deletedOn?: string
    readonly updatedBy?: string
    readonly updatedOn?: string
    readonly createdBy?: string
    readonly createdOn?: string
    readonly isBillable?: boolean
    readonly resourceType?: null
    readonly invoiceStatus?: TimeEntryInvoiceStatusEnum
    readonly clientId?: string | null
    readonly client?: User | null
    readonly isFlat?: boolean
    readonly invoiceNumber?: string
    readonly isSplitTime?: boolean
}
export interface TimeExpenseEntryInput extends TimeExpenseEntry {
    tag?: any
    timeEntryCategory?: TimeEntryCategory
    expenseCategory?: ExpenseCategory
    expenseCode?: UTBMSCode
    taskCode?: UTBMSCode
    tax?: Tax
    discountRate?: number
    discountType?: DiscountTypeEnum
    //NOTE : { Unspecified = 0, Tasks = 1, Events = 2, Communication = 3,Document=4}
}
export interface InitialState {
    timeExpenseEntries: TimeExpenseEntryResponse
    timeExpenseEntry: TimeExpenseEntry
    dependencyData: DependencyData
    hourlyRate?: number
    timeEntriesFromParent?: TimeExpenseEntry[]
   
}

export interface DependencyData {
    users: User[]
    hourlyRate?: number
    taskCodes?: UTBMSCode[] //TODO : get proper types from backend
    expenseCodes?: UTBMSCode[] //TODO : get proper types from backend
    timeEntryCategories?: TimeEntryCategory[] //TODO : get proper types from backend
    expenseCategories?: ExpenseCategory[] //TODO : get proper types from backend
    isEnableUtbms?: boolean
    taxes?: Tax[]
}

export type getDependencyDataPayload = {
    payload: DependencyData
}

export interface Matter {
    title?: string
    matterTitle?: string
    isSplitTime?: boolean
    id?: string
}

export interface User {
    firstName?: string
    lastName?: string
    email?: string
    id?: string
    userId?: string
    isCoCounsel?: boolean
}
export interface TimeExpenseEntryResponse {
    hasMore: boolean
    data: TimeExpenseEntry[] | null | Array<TimeExpenseEntry>
    rowCount: number
}

export interface Tax {
    isDefault?: boolean | null
    isGroup?: boolean | null
    parentTaxGroup?: null
    items?: Tax[]
    title?: string
    rate?: number
    description?: string
    id?: string
    parent?: null | string
    isActive?: boolean
}

export interface TimeExpenseEntryFilter extends Sortable {
    matterId?: string
    fromDate?: string
    toDate?: string
    employeeId?: string
    invoiceStatus?: BillingStatusEnum //all, billed, unbilled
    activityType?: ActivityTypeEnum.Unspecified | ActivityTypeEnum.Time | ActivityTypeEnum.Expense
    resourceId?: string
    resourceType?: 1 | 2 | 3 | 4
}

export interface InvoiceNumber {
    id?: string
    number?: string
}

export type getDataPayload = {
    payload: TimeExpenseEntryResponse
}

export type getRecordPayload = {
    payload: TimeExpenseEntry
}

export interface TimeEntryCategory {
    id: string
    title: string
    isUTBMSCode?: boolean
    rate?: number
    billingMethodType?: BillingMethodEnum
    code?: string
}
export interface ExpenseCategory {
    id: string
    title: string
    rate?: number
    taxTitle?: string
    taxRate?: number
    taxId?: string
    utbmsCodeId?: string
    utbmsTitle?: string
}
export interface UTBMSCode {
    id: string
    title: string
    code: string
}

export interface ValuesFromParent {
    description: string
    resourceId: string
    resourceType: 1 | 2 | 3 | 4
    parent?: string
    parentModule?: ParentModule
}
export interface ValuesFromInvoice extends TimeExpenseEntryInput {}
export enum BillingStatusEnum {
    Billed = 1,
    Unbilled = 0,
}

export enum OrderBy {
    ASC = 'asc',
    DESC = 'desc',
}

export type ParentModule = 'Matter' | 'Staff' | 'Billing'

export enum HourlyRatePriorityEnum {
    UserDefault = 0,
    Matter = 2,
    TimeEntryCaregory = 3,
}

export enum ResourceTypeEnum {
    Unspecified = 0,
    Tasks = 1,
    Events = 2,
    Communication = 3,
    Document = 4,
}

export enum ActivityTypeEnum {
    Unspecified = -1,
    Time = 1,
    Expense = 2,
}

export enum BillingMethodEnum {
    DefaultRate = 0,
    CustomRate = 1,
    FlatRate = 2,
}
export enum ResourceEntityType {
    Default = 0,
    Client = 1,
    Matter = 2,
    ExpenseCategory = 3,
    ActivityCategory = 4,
}
export enum InvoiceStatusEnum {
    Draft = 0,
    Pending_Approval = 1,
    Unpaid = 2,
    Paid = 3,
    Delete = 4,
    Void = 5,
}

export enum TimeEntryInvoiceStatusEnum {
    Unbilled = 0,
    Draft = 1,
    Billed = 2,
}

export enum DiscountTypeEnum {
    Unspecified = 0,
    Fixed_Amount = 1,
    Percentage = 2,
}
/**/

export interface ExternalRoleChecks {
    isMattersuiteCoCounsel?: boolean
    isMattersuiteClient?: boolean
}
export type Sortable = {
    sortBy?: string;
    orderBy?: SortDirection;
    sortDirection?: SortDirection | SortDirectionEnum;
};

export declare enum SortDirectionEnum {
    Asc = 0,
    Desc = 1
}
export type SortDirection = 'asc' | 'desc' | false;